module.exports = __webpack_public_path__ + "img/qihang_xiangqing_erjian.03955350.png";